import { useState } from 'react';

const allArticles = [
  {
    category: '醫療保險',
    categoryColor: '#FF8C69',
    title: '醫療險與實支實付險差在哪？',
    summary: '用生活化方式了解醫療費用、病房費、手術費與自費項目，協助您看懂基本保障差異，選出真正適合自己的醫療保障組合。',
    readTime: '5 分鐘',
    img: 'https://readdy.ai/api/search-image?query=medical%20health%20insurance%20documents%20stethoscope%20clipboard%20clean%20white%20desk%20professional%20healthcare%20minimal%20warm%20light&width=600&height=380&seq=art001&orientation=landscape',
    keywords: ['醫療險', '實支實付', '健康險'],
  },
  {
    category: '家庭保障',
    categoryColor: '#5C5470',
    title: '家庭主要經濟支柱，保險該怎麼配置？',
    summary: '當一個人的收入牽動整個家庭生活，保障規劃就不只是個人選擇，而是家庭安全結構。了解如何為家庭主要收入來源建立完整保障。',
    readTime: '6 分鐘',
    img: 'https://readdy.ai/api/search-image?query=family%20protection%20planning%20parents%20children%20home%20warm%20natural%20light%20safe%20secure%20lifestyle%20portrait%20minimal%20clean%20background&width=600&height=380&seq=art002&orientation=landscape',
    keywords: ['家庭保障', '收入保障', '壽險'],
  },
  {
    category: '保單健檢',
    categoryColor: '#D4A373',
    title: '為什麼保單需要定期健檢？',
    summary: '人生階段、收入、家庭責任與醫療制度都會改變，定期檢視保單能避免保障不足或重複配置，讓每一分保費都花在刀口上。',
    readTime: '4 分鐘',
    img: 'https://readdy.ai/api/search-image?query=insurance%20policy%20review%20documents%20analysis%20professional%20desk%20organized%20papers%20laptop%20modern%20clean%20office%20warm%20light&width=600&height=380&seq=art003&orientation=landscape',
    keywords: ['保單健檢', '保障缺口', '年度檢視'],
  },
  {
    category: '長期照護',
    categoryColor: '#FF8C69',
    title: '長期照護費用，該提前準備嗎？',
    summary: '照護風險不是老了才需要想，而是應該在還有選擇權時先做好準備。了解長期照護的費用結構與提前規劃的重要性。',
    readTime: '7 分鐘',
    img: 'https://readdy.ai/api/search-image?query=elderly%20care%20long%20term%20nursing%20home%20warm%20caring%20professional%20caregiver%20senior%20person%20comfortable%20safe%20environment%20natural%20light&width=600&height=380&seq=art004&orientation=landscape',
    keywords: ['長期照護', '長照費用', '照護規劃'],
  },
  {
    category: '退休規劃',
    categoryColor: '#5C5470',
    title: '退休生活需要哪些安全帳戶？',
    summary: '從生活費、醫療費、緊急預備金到旅遊與興趣支出，協助您建立更完整的退休現金流概念，讓退休生活有底氣、有品質。',
    readTime: '8 分鐘',
    img: 'https://readdy.ai/api/search-image?query=retirement%20planning%20financial%20security%20senior%20couple%20happy%20relaxed%20outdoor%20park%20warm%20golden%20hour%20lifestyle%20comfortable%20peaceful&width=600&height=380&seq=art005&orientation=landscape',
    keywords: ['退休規劃', '退休金流', '資產防護'],
  },
  {
    category: '理賠流程',
    categoryColor: '#D4A373',
    title: '申請理賠前，需要先準備哪些資料？',
    summary: '透過清楚步驟與資料清單，降低申請理賠時的不確定感與焦慮，讓您在最需要保障的時刻能從容應對。',
    readTime: '5 分鐘',
    img: 'https://readdy.ai/api/search-image?query=insurance%20claim%20documents%20preparation%20checklist%20professional%20advisor%20helping%20client%20paperwork%20support%20empathy%20care%20office%20warm%20light&width=600&height=380&seq=art006&orientation=landscape',
    keywords: ['理賠流程', '理賠文件', '保險申請'],
  },
];

const filterTabs = ['全部', '醫療保險', '家庭保障', '保單健檢', '長期照護', '退休規劃', '理賠流程'];

export default function KnowledgeArticles() {
  const [activeFilter, setActiveFilter] = useState('全部');

  const filtered = activeFilter === '全部'
    ? allArticles
    : allArticles.filter((a) => a.category === activeFilter);

  return (
    <section id="articles-section" className="bg-[#F8F5F0] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            FEATURED ARTICLES
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            精選文章
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-12">
          {filterTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveFilter(tab)}
              className={`px-5 py-2.5 rounded-full font-medium whitespace-nowrap transition-all duration-200 cursor-pointer
                ${activeFilter === tab
                  ? 'bg-[#5C5470] text-white'
                  : 'bg-white border border-gray-200 text-gray-600 hover:border-[#5C5470] hover:text-[#5C5470]'
                }`}
              style={{ fontSize: '1.0625rem' }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filtered.map((article) => (
            <article
              key={article.title}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#D4A373]/40 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              {/* Image */}
              <div className="h-48 overflow-hidden flex-shrink-0">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-7 flex flex-col flex-1">
                {/* Category + Read time */}
                <div className="flex items-center justify-between mb-4">
                  <span
                    className="px-3 py-1 rounded-full text-white font-medium"
                    style={{ fontSize: '1rem', backgroundColor: article.categoryColor }}
                  >
                    {article.category}
                  </span>
                  <span className="text-gray-400 flex items-center gap-1" style={{ fontSize: '1rem' }}>
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>

                {/* Title */}
                <h3
                  className="font-serif font-bold text-[#5C5470] mb-3"
                  style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.375rem)', lineHeight: '1.45' }}
                >
                  {article.title}
                </h3>

                {/* Summary */}
                <p className="text-gray-600 flex-1 mb-5" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                  {article.summary}
                </p>

                {/* Keywords */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {article.keywords.map((kw) => (
                    <span
                      key={kw}
                      className="bg-[#F8F5F0] text-gray-500 px-2.5 py-1 rounded-full"
                      style={{ fontSize: '1rem' }}
                    >
                      #{kw}
                    </span>
                  ))}
                </div>

                {/* Read More */}
                <button
                  className="inline-flex items-center gap-1.5 font-semibold text-[#D4A373] hover:text-[#c4935f] hover:gap-2.5 transition-all duration-200 cursor-pointer mt-auto"
                  style={{ fontSize: '1.0625rem' }}
                  onClick={() => {
                    document.getElementById('knowledge-cta')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  閱讀更多
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
